import React from "react";
import clsx from "clsx";
import styles from "./ValidationWrapper.module.scss";

export function ValidationWrapper(props) {
  return <div {...props} className={clsx(props.className, styles.wrapper)} />;
}
